module.exports = __webpack_public_path__ + "static/media/dream-gardens-aerial.533bc86f.png";